import { render, staticRenderFns } from "./guanYuWoMen.vue?vue&type=template&id=b7acc508&scoped=true"
import script from "./guanYuWoMen.vue?vue&type=script&lang=js"
export * from "./guanYuWoMen.vue?vue&type=script&lang=js"
import style0 from "./guanYuWoMen.vue?vue&type=style&index=0&id=b7acc508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7acc508",
  null
  
)

export default component.exports